/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ClockArrowDown = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227" }],
    ["path", { d: "M12 6v6l2 1" }],
    ["path", { d: "m14 18 4 4 4-4" }],
    ["path", { d: "M18 14v8" }]
  ]
];

export { ClockArrowDown as default };
//# sourceMappingURL=clock-arrow-down.js.map
